import React from 'react';
import PropTypes from "prop-types";
import TileCountVulnerableTargetsForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountVulnerableTargetsForCustomerInView";
import TileCountOutOfScopeTargetsForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountOutOfScopeTargetsForCustomerInView";
import TileCountIdentitiesForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountIdentitiesForCustomerInView";
import TileCountTargetsForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountTargetsForCustomerInView";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import TileCountServices from "../../../../../components/customBreachBits/metrics/TileCountServices";
import HumanIdentitiesDataTable from "../../../../../components/customBreachBits/targets/HumanIdentitesTable/HumanIdentitiesDataTable";
import TilePieHighRiskServices from "../../../../../components/customBreachBits/metrics/TilePieHighRiskServices";
import TargetsDataTable from "../../../../../components/customBreachBits/targets/TargetsTable/TargetsDataTable";
import VulnerableTargetsDataTable
    from "../../../../../components/customBreachBits/targets/VulnerableTargetsTable/VulnerableTargetsDataTable";

import TileCountCVEsForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountCVEsForCustomerInView";
import {HashLink as Link} from "react-router-hash-link";
const TargetsSection = (props, {children}) => {

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    //used to allow scrolling from clicking data tiles.
    // const refHumanTargetsTable = useRef(null);
    // const refSystemTargetsTable = useRef(null);
    // const refVulnerableTargetsTable = useRef(null);
    // const refDangerousServicesChart = useRef(null);

    const {customerId} = props;

    return (
        <div className={`bb-tab-section`}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <h3>Attack Surface <Tooltip title={"All Humans and Systems expose vulnerable & interactive elements to attackers."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                    <p>From the attacker's perspective, your <strong>Attack Surface</strong> includes everything that can be attacked.  CIRT constantly searches for Human and System targets and pairs them with attack capabilities to create <Tooltip title={"Vectors are the intersection of an attack opportunity and capability."}><strong>Vectors</strong></Tooltip>.</p>

                </div>
                {/*<div className={"col-3 align-self-center text-center"}>*/}
                {/*    /!*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesUserHaveAccessToModule(authUser, "perimeter")} iconSize={"80px"}/>*!/*/}
                {/*    <IconShowingIfCustomerHasAccessToModule module={"monitor"}/>*/}
                {/*</div>*/}
                {/*<div className={"col-3 align-self-center text-center"}>*/}
                {/*    /!*<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("perimeter", "id")} isActive={bbDoesUserHaveAccessToModule(authUser, "perimeter")} iconSize={"80px"}/>*!/*/}
                {/*    <IconShowingIfCustomerHasAccessToModule module={"social"}/>*/}
                {/*</div>*/}
            </div>
            <div className="row">

                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6 tourStepCVEs">
                    <Link smooth to={{hash:"VulnerableTargetsTable"}}>
                        <TileCountCVEsForCustomerInView/>
                    </Link>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepVulnerableTargets">
                    <Link smooth to={{hash:"VulnerableTargetsTable"}}>
                        <TileCountVulnerableTargetsForCustomerInView/>
                    </Link>
                </div>

                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepSystemTargets">
                    <Link smooth to={{hash:"SystemTargetsTable"}}>
                        <TileCountTargetsForCustomerInView/>
                    </Link>
                </div>

                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepServices">
                    <Link smooth to={{hash:"SystemTargetsTable"}}>
                        <TileCountServices/>
                    </Link>
                </div>

                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepTargetsOOS">
                    <Link smooth to={{hash:"SystemTargetsTable"}}>
                        <TileCountOutOfScopeTargetsForCustomerInView/>
                    </Link>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-4 tourStepHumanTargets">
                    <Link smooth to={{hash:"HumanTargetsTable"}}>
                        <TileCountIdentitiesForCustomerInView />
                    </Link>

                </div>
            </div>
            <hr/>
            <div className="row ">


                <div id={"VulnerableTargetsTable"} className="col-8 tourStepVulnerableTargetsTable">
                    <VulnerableTargetsDataTable customerId={customerId}/>
                </div>
                <div id={"DangerousServicesChart"} className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 tourStepHighRiskServices">
                    <TilePieHighRiskServices/>
                </div>
            </div>
            <div id={"SystemTargetsTable"} className="row">
                <div className="col-12">
                    <TargetsDataTable customerId={customerId}/>
                </div>
            </div>
            <div id={"HumanTargetsTable"} className="row">
                <div className="col-12">
                    <HumanIdentitiesDataTable customerId={customerId}/>
                </div>
            </div>
        </div>
    )
};

TargetsSection.propTypes = {
    customerId: PropTypes.string,
};

export default TargetsSection;

